import Storage from "./Storage";

/**
 * Created by cahyo on 18/02/19.
 */

export default class Preference {

  private static sidebarKey: string = "theme";

  private static langKey: string = "lang";

  public static getSidebar() {
    let sidebar: any = Storage.getCookie().get(Preference.sidebarKey);

    return sidebar || false;
  }

  public static getLang() {
    let lang: any = Storage.getCookie().get(Preference.langKey);

    return lang || '';
  }

  public static setLang(lang: string = 'ID') {
    Storage.getCookie().set(Preference.langKey, lang);
  }

  public static setSidebar(isExpanded: boolean = false) {
    Storage.getCookie().set(Preference.sidebarKey, isExpanded);
  }
}
